export default __webpack_public_path__ + "static/media/beats_harp_clip.55eabf74.mp3";